/**
 * KOSIMA: "Model view" switch in the collection toolbar.
 *
 * A deliberate copy of Prestige's own <collection-layout-switch> (assets/theme.js): the click
 * flips the control immediately, writes the chosen mode onto the <product-list> it controls, and
 * persists the choice as a cart attribute. The section reads that attribute back in Liquid
 * (sections/main-collection.liquid), which is what makes the choice survive the facet re-render --
 * filtering replaces the whole section from server HTML -- and the next page load.
 *
 * Modes: "model" (default) and "packshot". Nothing acts on the attribute yet; the product card
 * starts swapping images once products carry packshots. See MODEL_VIEW_DECISIONS.md.
 *
 * Kept out of theme.js so a Prestige update cannot drop it.
 */
(() => {
  if (window.customElements.get('model-view-switch')) return;

  const MODES = { on: 'model', off: 'packshot' };
  const CART_ATTRIBUTE = 'products_view_mode';

  class ModelViewSwitch extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    get button() {
      return this.querySelector('button[role="switch"]');
    }

    get controlledList() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }

    onClick = (event) => {
      const button = this.button;
      if (!button || !button.contains(event.target)) return;

      const checked = button.getAttribute('aria-checked') !== 'true';
      const mode = checked ? MODES.on : MODES.off;

      button.setAttribute('aria-checked', String(checked));
      this.controlledList?.setAttribute('view-mode', mode);

      this.dispatchEvent(new CustomEvent('model-view:change', { bubbles: true, detail: { mode } }));

      // keepalive so the write lands even if the shopper navigates straight away -- same as the
      // grid-mode switch. A failed write is not actionable: the page still reflects the choice.
      fetch(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [CART_ATTRIBUTE]: mode } }),
        keepalive: true,
      }).catch(() => {});
    };
  }

  window.customElements.define('model-view-switch', ModelViewSwitch);
})();
